import React from 'react'
import PropTypes from 'prop-types'
import CTAButton from '../CTAButton/CTAButton'
import { ContentContainer, ContentWrapper, Header, Headline, Description } from './styles'

export default function CopyBlock({
  heading,
  description,
  useCTA,
  ctaText,
  ctaLink,
  ctaVariant,
  ctaAnalytics,
  textLeft,
}) {
  return (
    <ContentContainer>
      <ContentWrapper textLeft={textLeft}>
        <Header>
          <Headline textLeft={textLeft}>{heading}</Headline>
          <Description textLeft={textLeft}>{description}</Description>
        </Header>
        {useCTA && (
          <CTAButton ctaLink={ctaLink} ctaVariant={ctaVariant} ctaAnalytics={ctaAnalytics}>
            {ctaText}
          </CTAButton>
        )}
      </ContentWrapper>
    </ContentContainer>
  )
}

CopyBlock.propTypes = {
  heading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  useCTA: PropTypes.bool.isRequired,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  ctaVariant: PropTypes.bool,
  ctaAnalytics: PropTypes.string,
  textLeft: PropTypes.bool,
}
